

export const showNotification = (message, type = 'success', duration = 3000) => {
  const notification = document.createElement('div');
  notification.className = 'notification-toast';
  
  const styles = {
    success: {
      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      icon: '✅'
    },
    error: {
      background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
      icon: '❌'
    },
    info: {
      background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
      icon: 'ℹ️'
    },
    warning: {
      background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
      icon: '⚠️'
    }
  };
  
  const style = styles[type] || styles.info;
  
  notification.style.background = style.background;
  notification.innerHTML = `
    <span class="notification-icon">${style.icon}</span>
    <span class="notification-message">${message}</span>
  `;
  
  document.body.appendChild(notification);
  
  setTimeout(() => {
    notification.style.animation = 'slideOut 0.5s ease-out forwards';
    setTimeout(() => {
      if (notification.parentNode) {
        document.body.removeChild(notification);
      }
    }, 500);
  }, duration);
  
  notification.addEventListener('click', () => {
    notification.style.animation = 'slideOut 0.3s ease-out forwards';
    setTimeout(() => {
      if (notification.parentNode) {
        document.body.removeChild(notification);
      }
    }, 300);
  });
};

export default showNotification;